
import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import Loader from '../../loader/Loader';
import Footer from '../Footer/Footer';
import Terms from './Terms';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';

function TermsMain() {
    const { t, locale } = useLocale();
   const[loader, SetLoader] = useState(false)
    useEffect(() => {
        const timer = setTimeout(() => {
            SetLoader(true)
        },1500)

        return () => clearTimeout(timer)
    }, [])
    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <PageSEO title={t('meta.termsTitle')} description={t('meta.termsDescription')} path="/terms-of-service" locale={locale} />
            <Terms/>
            <Footer/>
        </Fragment>
    )
    
}

export default TermsMain;